import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logError } from "common-event";
import { NotFoundCard } from "../NotFoundCard/NotFoundCard";
import { PageNotFoundPropsModel } from "./tools/PageNotFound.model";

export const PageNotFound = ({ i18NextNamespace = 'translation' } : PageNotFoundPropsModel) => {
  const history = useHistory();
  const [t] = useTranslation(i18NextNamespace);

  useEffect(() => {
    logError("404 error");
  }, []);

  return (
    <NotFoundCard
      onRedirect={() => history.push("/")}
      title="404"
      description={t("page-not-found.title")}
      redirectLinkLabel={t("page-not-found.to-my-wallet")}
    />
  );
};
